module.exports = __webpack_public_path__ + "static/CubeTopDown_h264-29df89c8512857b82e0929dfe9aab2d7.jpg";